import styles from './Footer.module.css';
import typography from '../../theme/typography';
import colors from '../../theme/colors';

const MIT_ACCESSIBILITY_URL = 'https://accessibility.mit.edu/';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
      <span
        style={{ ...typography.body.small.regular, color: colors.gray[800] }}
      >
        @{year} DATA TO AI LAB
      </span>
      <a
        href={MIT_ACCESSIBILITY_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...typography.body.small.regular, color: colors.gray[800] }}
        className={styles.footerLink}
      >
        Accessibility
      </a>
      </div>
    </footer>
  );
};

export default Footer;
